import * as yup from 'yup';
import { alphabet_regix, numeric_integer_regix, splitPhoneNumberAndCode } from '../utils/functions';

export const contact_information_schema = (data) => ({
    corpClientApplicationContactPersonInfoId: data?.corpClientApplicationContactPersonInfoId ?? 0,
    contactPersonName: data?.contactPersonName ?? '',
    jobTitle: data?.jobTitle ?? '',
    workPhoneCountry: data?.workPhoneNumber ? splitPhoneNumberAndCode(data?.workPhoneNumber)?.country : '',
    workPhoneNumber: data?.workPhoneNumber ? splitPhoneNumberAndCode(data?.workPhoneNumber)?.number : '',
    mobileNumberCountry: data?.mobileNumber ? splitPhoneNumberAndCode(data?.mobileNumber)?.country : '',
    mobileNumber: data?.mobileNumber ? splitPhoneNumberAndCode(data?.mobileNumber)?.number : '',
    address: data?.address ?? '',
    workEmail: data?.workEmail ?? '',
    preferredLanguageForCorrespondence: data?.preferredLanguageForCorrespondence ?? null,
    buildingNumberKsa: data?.buildingNumberKsa ?? '',
    streetNameKsa: data?.streetNameKsa ?? '',
    districtKsa: data?.districtKsa ?? '',
    cityKsa: data?.cityKsa ?? '',
    postalCodeKsa: data?.postalCodeKsa ?? '',
    additionalNumberKsa: data?.additionalNumberKsa ?? '',
    unitNoKsa: data?.unitNoKsa ?? '',
    // addressNonKsa: data?.addressNonKsa ?? '',
    // cityNonKsa: data?.cityNonKsa ?? '',
    // postalOrZipCodeNonKsa: data?.postalOrZipCodeNonKsa ?? '',
    // provinceStateOrRegionNonKsa: data?.provinceStateOrRegionNonKsa ?? '',
    // countryNonKsa: data?.countryNonKsa ?? '',
});

export const contact_information_validation_schema = yup.object().shape({
    contactPersonName: yup
        .string()
        // .required('contact_person_required')
        .matches(alphabet_regix, 'characters_should_be_alphabets')
        .nullable(),
    jobTitle: yup
        .string()
        // .required('job_title_required')
        .matches(alphabet_regix, 'characters_should_be_alphabets')
        .nullable(),
    workPhoneNumber: yup
        .string()
        // .required('work_phone_required')
        .test('work-phone-numeric', 'input_should_be_numeric', (value) => !value || numeric_integer_regix.test(value))
        .nullable(),
    mobileNumber: yup
        .string()
        // .required('mobile_number_required')
        .matches(numeric_integer_regix, 'input_should_be_numeric')
        .nullable(),
    address: yup
        .string()
        .nullable(),
        // .required('address_required'),
    workEmail: yup
        .string()
        // .required('work_email_required')
        .email('invalid_email')
        .nullable(),
    preferredLanguageForCorrespondence: yup
        .number()
        .nullable(),
        // .required('preferred_language_required'),
    buildingNumberKsa: yup
        .string()
        .nullable(),
        // .required('building_number_required'),
    streetNameKsa: yup
        .string()
        .nullable(),
        // .required('street_name_required'),
    districtKsa: yup
        .string()
        .nullable(),
        // .required('district_required'),
    cityKsa: yup
        .string()
        .nullable(),
        // .required('city_required'),
    postalCodeKsa: yup
        .string()
        // .required('postal_code_required')
        .matches(numeric_integer_regix, 'input_should_be_numeric')
        .nullable(),
    additionalNumberKsa: yup
        .string()
        // .required('additional_number_required')
        .matches(numeric_integer_regix, 'input_should_be_numeric')
        .nullable(),
    unitNoKsa: yup
        .string()
        .nullable(),
        // .required('unit_no_required'),
    // addressNonKsa: yup
    //     .string()
    //     .required('address_non_ksa_required'),
    // cityNonKsa: yup
    //     .string()
    //     .required('city_non_ksa_required'),
    // postalOrZipCodeNonKsa: yup
    //     .string()
    //     .required('postal_or_zip_code_non_ksa_required'),
    // provinceStateOrRegionNonKsa: yup
    //     .string()
    //     .required('province_state_or_region_non_ksa_required'),
    // countryNonKsa: yup
    //     .number()
    //     .required('country_non_ksa_required'),
});